import Button from '../components/ui/Button';
import Seo from '../components/Seo';

export default function NotFound() {
  return (
    <>
      <Seo title="Page Not Found" path="/404" noindex />
      <div className="min-h-[60vh] flex items-center justify-center px-4">
      <div className="text-center">
        <h1 className="text-6xl md:text-8xl font-display font-bold text-blush-200 mb-4">
          404
        </h1>
        <h2 className="text-2xl md:text-3xl font-display font-semibold text-charcoal mb-4">
          Page Not Found
        </h2>
        <p className="text-gray-600 mb-8 max-w-md mx-auto">
          Oops! The page you're looking for doesn't exist. Let's get you back on track.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button to="/">
            Back to Home
          </Button>
        </div>
      </div>
    </div>
    </>
  );
}
